// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared sparkle / ice-flake decor. Positions live with each screen. */
.sparkles {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

/* Four-point sparkles. */
.spark {
  position: absolute;
  width: 1.05rem;
  height: 1.05rem;
  background: var(--white);
  clip-path: polygon(
    50% 0,
    62% 38%,
    100% 50%,
    62% 62%,
    50% 100%,
    38% 62%,
    0 50%,
    38% 38%
  );
  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 1));
  animation: twinkle 2.2s ease-in-out infinite;
}

/* Six-point ice flakes. */
.flake {
  position: absolute;
  width: 2px;
  height: 12px;
  background: var(--sky-strong);
  border-radius: 1px;
  opacity: 0.85;
  animation: flakeDrift 7s ease-in-out infinite;
}

.flake::before,
.flake::after {
  content: "";
  position: absolute;
  inset: 0;
  background: inherit;
  border-radius: inherit;
}

.flake::before { transform: rotate(60deg); }
.flake::after { transform: rotate(120deg); }

@keyframes twinkle {
  0%, 100% { transform: scale(0.45) rotate(0deg); opacity: 0.35; }
  50% { transform: scale(1) rotate(20deg); opacity: 1; }
}

@keyframes flakeDrift {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(10px) rotate(18deg); }
}

@media (prefers-reduced-motion: reduce) {
  .spark,
  .flake {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/sparkles.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB;;;;;;;;;GASC;EACD,mDAAmD;EACnD,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,iBAAiB,wBAAwB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;;AAE3C;EACE,WAAW,mCAAmC,EAAE,aAAa,EAAE;EAC/D,MAAM,iCAAiC,EAAE,UAAU,EAAE;AACvD;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;AACnD;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Shared sparkle / ice-flake decor. Positions live with each screen. */\n.sparkles {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Four-point sparkles. */\n.spark {\n  position: absolute;\n  width: 1.05rem;\n  height: 1.05rem;\n  background: var(--white);\n  clip-path: polygon(\n    50% 0,\n    62% 38%,\n    100% 50%,\n    62% 62%,\n    50% 100%,\n    38% 62%,\n    0 50%,\n    38% 38%\n  );\n  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 1));\n  animation: twinkle 2.2s ease-in-out infinite;\n}\n\n/* Six-point ice flakes. */\n.flake {\n  position: absolute;\n  width: 2px;\n  height: 12px;\n  background: var(--sky-strong);\n  border-radius: 1px;\n  opacity: 0.85;\n  animation: flakeDrift 7s ease-in-out infinite;\n}\n\n.flake::before,\n.flake::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: inherit;\n  border-radius: inherit;\n}\n\n.flake::before { transform: rotate(60deg); }\n.flake::after { transform: rotate(120deg); }\n\n@keyframes twinkle {\n  0%, 100% { transform: scale(0.45) rotate(0deg); opacity: 0.35; }\n  50% { transform: scale(1) rotate(20deg); opacity: 1; }\n}\n\n@keyframes flakeDrift {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50% { transform: translateY(10px) rotate(18deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spark,\n  .flake {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
